import { applyOp } from './apply'
import type { ReplaySchedule } from './schedule'
import type { KeystrokeLog } from './types'

export const DEFAULT_CHECKPOINT_GAP_MS = 250

/**
 * Op counts at which the document is valid (per `isValid`) and at least `minGapMs` of replay time
 * has passed since the previous checkpoint. The final document is always considered, so a replay
 * never ends on a stale frame. Use `docAt(log, n)` to materialise a checkpoint.
 */
export function checkpoints(
  log: KeystrokeLog,
  isValid: (doc: string) => boolean,
  schedule: ReplaySchedule,
  minGapMs = DEFAULT_CHECKPOINT_GAP_MS,
): readonly number[] {
  if (schedule.times.length !== log.ops.length) {
    throw new RangeError('schedule does not match the log')
  }
  const result: number[] = []
  let lastAt = -Infinity
  let doc = ''
  const consider = (count: number, at: number, force: boolean): void => {
    if (!force && at - lastAt < minGapMs) return
    if (!isValid(doc)) return
    result.push(count)
    lastAt = at
  }
  consider(0, 0, true)
  log.ops.forEach((op, i) => {
    doc = applyOp(doc, op)
    const isLast = i === log.ops.length - 1
    consider(i + 1, schedule.times[i] as number, isLast)
  })
  return result
}
